// source content/page values
export const BOW = 'BOW';
export const RECOMMENDED_VENDORS = 'recommended vendors';
